import { createContext, useContext } from 'react';
import { Button, Image } from '@apia/theme';
import conf from '../../../../../classes/configController';
import IconsUploaderListElement from './IconsUploaderListElement';
import MenuUploaderListElement from './menuElement/MenuUploaderListElement';
import { TUploaderListElement } from './UploaderListElement';
import { ApiaComponentContextPrimitive } from '../../apiaComponent/ApiaComponentContext';
import usePropsSelector from '../../../../../store/propsStore/usePropsSelector';
import { getLabel } from '../../../../../utils/util';
import useModal from '../../../../../hooks/useModal';
import { Modal } from '../../../../common';

export const FileElementContext = createContext<TUploaderListElement>(
  {} as TUploaderListElement,
);

function isImage(fileName: string) {
  return fileName.match(/.*\.(jpg|jpeg|png|gif|bmp|tif|tiff)$/i);
}

const FileElement = (props: TUploaderListElement) => {
  const context = useContext(ApiaComponentContextPrimitive);
  const showFilePreview = usePropsSelector(
    context?.fieldId ?? 'NONAME',
    (current) => current.field?.properties.filePreview,
  );

  const shouldShowPreview =
    showFilePreview &&
    props.file.preview &&
    isImage(props.file.name || (props.file.docName as string));

  const { show, ...modalProps } = useModal();

  return (
    <FileElementContext.Provider value={props}>
      {conf('components.uploader.view', 'menu') === 'menu' ? (
        <MenuUploaderListElement autoFocus={props.autoFocus} />
      ) : (
        <IconsUploaderListElement />
      )}
      <Modal size="xxxl" {...modalProps}>
        <Image role="presentation" src={props.file.preview} alt="" />
      </Modal>
      {shouldShowPreview && (
        <Button
          className="file__preview"
          onClick={show}
          title={getLabel('prpPreview').text}
        >
          <Image role="presentation" src={props.file.preview} alt="" />
        </Button>
      )}
    </FileElementContext.Provider>
  );
};

export default FileElement;
